module.exports = __webpack_public_path__ + "img/logo-icon.351e0eb8.png";